module.exports = "/assets/data/fa122fb178c3cda1b4592aa34b2147fa-IG6.data.json";